export default __webpack_public_path__ + "static/media/cover.1e4dfa19.jpg";